import { DOUBLE_DASH } from 'consts/placeholders';
import { Network } from 'components/common/types/Network.types';
import Timeline, { TimelineItem } from 'lib/Timeline';

import NetworkInfo from './NetworkInfo';
import ReadMoreButton from '../ReadMoreSections/Button';

type NetworksProps = {
  networks?: Network[];
  toggleReadMore?: () => void;
  maxRecordsToShow: number;
};

const Networks = ({
  networks = [],
  toggleReadMore = (): null => null,
  maxRecordsToShow,
}: NetworksProps): React.ReactElement => {
  return (
    <div>
      <h2 className="sub-header-base mb-8">Networks</h2>
      <div className="pl-2" data-test-id="network-container">
        <Timeline>
          {networks.length ? (
            networks
              .slice(0, maxRecordsToShow)
              .map((network) => <NetworkInfo key={network.networkUuid} network={network} />)
          ) : (
            <TimelineItem title={<p className="body-base">{DOUBLE_DASH}</p>} />
          )}
        </Timeline>
        {networks.length > 3 ? <ReadMoreButton onClick={toggleReadMore} /> : null}
      </div>
    </div>
  );
};

export default Networks;
